import React, { useState } from 'react';
import { HelpCircle } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const sections = [
  {
    title: 'Text',
    items: [
      { syntax: '**bold**', desc: 'Bold' },
      { syntax: '*italic*', desc: 'Italic' },
      { syntax: '~~text~~', desc: 'Strikethrough' },
      { syntax: '`code`', desc: 'Inline code' },
    ]
  },
  {
    title: 'Headings',
    items: [
      { syntax: '# Heading 1', desc: 'Largest' },
      { syntax: '## Heading 2', desc: '' },
      { syntax: '### Heading 3', desc: 'through ######' },
    ]
  },
  {
    title: 'Blocks',
    items: [
      { syntax: '```lang\\ncode\\n```', desc: 'Code block' },
      { syntax: '> text', desc: 'Blockquote' },
      { syntax: '---', desc: 'Horizontal rule' },
    ]
  },
  {
    title: 'Lists',
    items: [
      { syntax: '- item', desc: 'Bulleted list' },
      { syntax: '1. item', desc: 'Numbered list' },
    ]
  },
  {
    title: 'Links & Tables',
    items: [
      { syntax: '[text](url)', desc: 'Link' },
      { syntax: '| H1 | H2 |\\n|---|---|\\n| a | b |', desc: 'Table' },
    ]
  },
  {
    title: 'Images',
    items: [
      { syntax: 'Use Gallery / Upload buttons', desc: 'Inserts image tag at cursor' },
    ]
  }
];

export function MarkdownHelpModal() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="text-xs text-muted-foreground hover:text-primary transition-colors flex items-center gap-1"
        data-testid="markdown-help-link"
      >
        <HelpCircle className="h-3 w-3" />
        Markdown Guide
      </button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md max-h-[80vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Markdown Reference</DialogTitle>
          </DialogHeader>
          <div className="space-y-4 mt-2">
            {sections.map((section) => (
              <div key={section.title}>
                <h3 className="text-xs font-semibold uppercase tracking-wider text-muted-foreground mb-2">
                  {section.title}
                </h3>
                <div className="space-y-1">
                  {section.items.map((item, i) => (
                    <div key={i} className="flex items-baseline gap-3 text-sm">
                      <code className="bg-muted px-1.5 py-0.5 rounded text-xs font-mono whitespace-pre flex-shrink-0">
                        {item.syntax}
                      </code>
                      {item.desc && (
                        <span className="text-muted-foreground text-xs">{item.desc}</span>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
}
